<template>
  <page-header-wrapper>
    <a-card :bordered="false" title="宠物体重引导图">
      <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="第一步：放置坐垫">
          <file-upload
            v-model="step1.configValue"
            type="image"
            :count="1"
            @change="(url) => changeImage('step1', url)"
          />
          <div class="tip">对应小程序「第一步：放置宠物坐垫」示意区</div>
        </a-form-model-item>
        <a-form-model-item label="第二步：放置宠物">
          <file-upload
            v-model="step2.configValue"
            type="image"
            :count="1"
            @change="(url) => changeImage('step2', url)"
          />
          <div class="tip">对应小程序「第二步：放置宠物」示意区</div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" :loading="submitLoading" @click="handleSave">
            保存
          </a-button>
          <a-button style="margin-left: 8px" @click="loadData">
            重置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listSiteConfig, updateSiteConfig, addSiteConfig } from '@/api/mibo/siteConfig'

const STEP1_KEY = 'pet_weight_step1_img'
const STEP2_KEY = 'pet_weight_step2_img'

export default {
  name: 'WeightGuide',
  data () {
    return {
      submitLoading: false,
      step1: {
        id: null,
        configKey: STEP1_KEY,
        configName: '宠物体重-第一步示意(放置坐垫)',
        configValue: null,
        sort: 6,
        status: 1
      },
      step2: {
        id: null,
        configKey: STEP2_KEY,
        configName: '宠物体重-第二步示意(放置宠物)',
        configValue: null,
        sort: 7,
        status: 1
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    changeImage (which, url) {
      this[which].configValue = url
    },
    loadData () {
      listSiteConfig({}).then(response => {
        const list = (response && response.data) || []
        const s1 = list.find(item => item.configKey === STEP1_KEY)
        const s2 = list.find(item => item.configKey === STEP2_KEY)
        if (s1) {
          this.step1 = { ...this.step1, ...s1 }
        }
        if (s2) {
          this.step2 = { ...this.step2, ...s2 }
        }
      })
    },
    saveOne (item) {
      if (item.id) {
        return updateSiteConfig(item)
      }
      return addSiteConfig(item)
    },
    handleSave () {
      if (!this.step1.configValue || !this.step2.configValue) {
        this.$message.warning('请先上传两张引导图')
        return
      }
      this.submitLoading = true
      Promise.all([this.saveOne(this.step1), this.saveOne(this.step2)])
        .then(results => {
          const failed = results.find(res => !res.success)
          if (failed) {
            this.$message.error(failed.message || failed.msg || '保存失败')
            return
          }
          this.$message.success('保存成功')
          this.loadData()
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style scoped>
.tip {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  margin-top: 8px;
}
</style>
